import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import App from "./App";
import ThesisUBC from "./components/ThesisUBC";
import ThesisKIC from "./components/ThesisKIC";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/thesis/UBC" element={<ThesisUBC />} />
        <Route path="/thesis/KIC" element={<ThesisKIC />} />
      </Routes>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
